/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CheckBoxConfig } from 'libs/sysque/shared/ui/src/lib/models/check-box-config';
import { SysqueNumberBoxVM } from 'libs/sysque/shared/ui/src/lib/models/sysque-number-box-vm';

export class ConvertOptionState {
  selectedCategory: string = '';
  selectedSystem: string = '';
  checkBoxConfigs: CheckBoxConfig[] = [];
  isHangerNeeded = false;
  isCableTrayClearanceNeeded = false;
  onlyFittingProcess = false;
  processingEnabled: any;
  showNonStandard: any;
  cableTrayNumberText: SysqueNumberBoxVM[] = [];
  projectName: string = '';
  projectAndPanelName: string[] = [];
  wirefillSpec: string = '';
}
